var _ellipse, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_225",
    "data-name": "Group 225",
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.06,
    height: 56.06,
    viewBox: "0 0 56.06 56.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 28.03,
    cy: 28.03,
    rx: 28.03,
    ry: 28.03,
    transform: "translate(0)",
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_76576",
    "data-name": "Path 76576",
    d: "M3.824,1.88H7.813L25.43,25.435H21.441ZM25.284,0,16.142,9.877,8.755,0H.071L11.338,15.065,0,27.314H2.552L12.479,16.59,20.5,27.314h8.684L17.282,11.4,27.836,0Z",
    transform: "translate(13.438 14.373)",
    fill: "#04253d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.6b0ca5d34cdc8906884bb299a3b4318b.svg";
export { ForwardRef as ReactComponent };